import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Popover, { PopoverAnimationVertical } from 'material-ui/Popover';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Menu from 'material-ui/Menu';

import { updateCargoOrder, updateCargoOrderUser } from 'actions/cargoes/orders';

class SelectedTextPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            numberCargoOrder: null,
        };

        this.selectCargoOrder = this.selectCargoOrder.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    getFirstSetNumbersFromString() {
        const reg = new RegExp(/[.,0-9]+/gi);
        const matchArray = this.props.chosenText.match(reg);
        
        if (matchArray) {
            return matchArray[0].replace(',', '.');
        }

        return '';
    }

    onChange(e, fieldValue) {
        if (this.state.numberCargoOrder === null) {
            return;
        }

        const newCargoOrder = _.cloneDeep(this.props.cargoOrders[this.state.numberCargoOrder]);
        const newUser = _.cloneDeep(this.props.cargoOrderUser);
   
        switch(fieldValue) {
        case 'cargoName':
            newCargoOrder.cargo.cargoName = this.props.chosenText;
            break;
        case 'uport':
            newCargoOrder.loadingPorts[0].namePort = this.props.chosenText;
            break;
        case 'lport':
            newCargoOrder.unloadingPorts[0].namePort = this.props.chosenText;
            break;
        case 'term':
            newCargoOrder.terms.user.push({ type: '', value: this.props.chosenText });
            break;
        case 'comm':
            newCargoOrder.comm = this.props.chosenText;
            break;
        case 'sf':
            newCargoOrder.cargo.sf = this.props.chosenText;
            break;
        case 'un':
            newCargoOrder.cargo.dangerous.unNumber = this.getFirstSetNumbersFromString();
            break;
        case 'imdg':
            newCargoOrder.cargo.dangerous.class[0] = this.getFirstSetNumbersFromString();
            break;
        case 'weight':
            newCargoOrder.cargo.packing.pack.unitsWeight.value = this.getFirstSetNumbersFromString();
            break;
        case 'volume':
            newCargoOrder.cargo.packing.pack.unitsVolume.value = this.getFirstSetNumbersFromString();
            break;
            // todo check for autocomplete user
        case 'email':
            newUser.email = this.props.chosenText;
            break;
        case 'company':
            newUser.company = this.props.chosenText;
            break;
        case 'name':
            newUser.name = this.props.chosenText;
            break;
        case 'surname':
            newUser.surname = this.props.chosenText;
            break;
        case 'phonecode':
            newUser.phones[0].code = this.props.chosenText;
            break;
        case 'phone':
            newUser.phones[0].phone = this.props.chosenText;
            break;
        }

        
        this.props.updateCargoOrder(this.state.numberCargoOrder, newCargoOrder);
        this.props.updateCargoOrderUser(newUser);
        this.props.closePopover();
    }
    
    selectCargoOrder(e, index, value) {
        this.setState({
            numberCargoOrder: value,
        });
    }

    render() {
        let renderMenu = (<Menu onChange={this.onChange}>
            <MenuItem primaryText='Cargo Name' value='cargoName' />
            <MenuItem primaryText='Unloading port' value='uport' />
            <MenuItem primaryText='Loading port' value='lport' />
            <MenuItem primaryText='Term' value='term' />
            <MenuItem primaryText='Commision' value='comm' />
            <MenuItem primaryText='SF' value='sf' />
            <MenuItem primaryText='unNumber' value='un' />
            <MenuItem primaryText='IMDG' value='imdg' />
            <MenuItem primaryText='Weight' value='weight' />
            <MenuItem primaryText='Volume' value='volume' />

            <MenuItem primaryText='Email user' value='email' />
            <MenuItem primaryText='Company new user' value='company' />
            <MenuItem primaryText='Name new user' value='name' />
            <MenuItem primaryText='Surname new user' value='surname' />
            <MenuItem primaryText='Phone code new user' value='phonecode' />
            <MenuItem primaryText='Phone number new user' value='phone' />
        </Menu>);
        
        if (this.state.numberCargoOrder === null) {
            renderMenu = null;
        }
        
        return (
            <div className='popup'>
                <Popover
                    open={this.props.openPopover}
                    anchorEl={this.props.anchorEl}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                    onRequestClose={this.props.closePopover}
                    animation={PopoverAnimationVertical}
                >
                    <div className='popup-choose'>
                        <div className='chosen'>
                            <div className='chosen-title'>
                                Chosen text
                            </div>
                            <div className='chosen-row'>
                                {`'${this.props.chosenText}'`}
                            </div>
                        </div>

                        <SelectField
                            floatingLabelText='Choose cargo order'
                            value={this.state.numberCargoOrder}
                            onChange={this.selectCargoOrder}
                            style={{
                                width: '200px',
                                padding: '0 10px',
                            }}
                        >
                            {
                                this.props.cargoOrders.map((item, i) => {
                                    return (<MenuItem
                                        key={i}
                                        value={i}
                                        primaryText={`Cargo order - ${i}`}
                                    />);
                                })
                            }
                        </SelectField>
                        {renderMenu}
                    </div>
                </Popover>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {
            openPopover: ownProps.openPopover,
            anchorEl: ownProps.anchorEl,
            closePopover: ownProps.closePopover,
            chosenText: ownProps.chosenText,
            cargoOrders: state.cargoOrders.items,
            cargoOrderUser: state.cargoOrders.user,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
        updateCargoOrderUser,
    }, dispatch),
)(SelectedTextPopup);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Content/SelectedTextPopup.jsx